module.exports = __webpack_public_path__ + "media/brands/montesa-honda-41bbfc9e.png";